import { useState } from 'react';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { getVuoadminLoginReasons } from 'shared-helpers/common';
import { useApiData } from 'lib/api';
import { DisplayFormattedDate, Pagination } from 'components/common';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import { AccessListDownload } from '.';

const AccessList = () => {
  const { messages } = useReduxState();

  const [page, setPage] = useState(1);

  const { data, loading } = useApiData({
    url: `/admin/events?type=vuoadmin-login-request&page=${page}`
  });

  const reasons = getVuoadminLoginReasons(messages);

  return (
    <div className="access-list">
      <Box
        headerContent={<AccessListDownload />}
        loading={loading}
        padding={0}
        title={messages.adminVuoadminLogins}
      >
        {data?.events?.length ? (
          <BoxTable>
            <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
              <BoxTableCell>{messages.commonUser}</BoxTableCell>
              <BoxTableCell>{messages.authVuoadminLoginReason}</BoxTableCell>
              <BoxTableCell>{messages.commonTime}</BoxTableCell>
            </BoxTableHeader>

            {data.events.map((event) => (
              <BoxTableRow key={event.id}>
                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.commonUser}
                >
                  {event.data ? event.data.email : null}
                </BoxTableCell>
                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.authVuoadminLoginReason}
                >
                  {event.data ? reasons[event.data.reason] : null}
                </BoxTableCell>
                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.commonTime}
                >
                  <DisplayFormattedDate
                    date={event.createdAt}
                    dateFormat="dd.MM.y HH:mm"
                  />
                </BoxTableCell>
              </BoxTableRow>
            ))}
          </BoxTable>
        ) : null}
      </Box>

      <Pagination
        currentPage={page}
        numberOfPages={data?.pages || 1}
        onPageChange={({ page }) => setPage(page)}
      />
    </div>
  );
};

export default AccessList;
